import React from 'react';
import { novaThemes, NovaThemeName } from './novaTheme';

interface NovaBetaTagProps {
  theme: NovaThemeName;
  className?: string;
  height?: number;
}

const NovaBetaTag: React.FC<NovaBetaTagProps> = ({ theme, className, height = 16 }) => (
  <svg
    viewBox="2.49 88.03 249.99 78.9"
    className={className}
    style={{ height, width: 'auto', display: 'block', flex: '0 0 auto' }}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Beta"
  >
    <g fill={novaThemes[theme].ink.heading}>
      <polygon points="179.1 131.38 189 131.38 184.03 117.93 179.1 131.38" />
      <path d="M68.46,130.02h-7.95v8.97h7.95c3.51,0,5.41-1.8,5.41-4.48s-1.9-4.48-5.41-4.48Z" />
      <path d="M72.94,120.08c0-2.73-2-4.14-5.56-4.14h-6.87v8.29h6.87c3.56,0,5.56-1.36,5.56-4.14Z" />
      <path d="M213.03,88.03H41.94c-21.79,0-39.45,17.66-39.45,39.45h0c0,21.79,17.66,39.45,39.45,39.45h171.09c21.79,0,39.45-17.66,39.45-39.45h0c0-21.79-17.66-39.45-39.45-39.45ZM68.94,144.99h-15.31v-35h14.43c7.6,0,11.65,3.31,11.65,9.31,0,4.19-2.49,6.48-4.87,7.51,3.51,1.17,5.95,4.14,5.95,8.38,0,6.14-4.44,9.8-11.85,9.8ZM118.96,116.18h-17.11v7.8h14.33v6.14h-14.33v8.68h17.11v6.19h-24.18v-35h24.18v6.19ZM160.44,116.18h-10.97v28.81h-7.17v-28.81h-11.02v-6.19h29.15v6.19ZM194.07,144.99l-2.78-7.51h-14.43l-2.78,7.51h-7.12l13.06-35h8.19l13.11,35h-7.26Z" />
    </g>
  </svg>
);

export default NovaBetaTag;
